import SvgPause from '@sats-group/icons/18/pause';
import SvgPlay from '@sats-group/icons/18/play';
import Button from '@sats-group/ui-lib/react/button';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React, { useState } from 'react';
import BackgroundImage from '../background-image/background-image';
import Tagline from '../tagline/tagline';
import type { Showcase as Props } from './showcase.types';

const Showcase: React.FC<Props> = ({
  actions,
  secondaryTitle,
  firstRowItems,
  secondRowItems,
  tagline,
  title,
}) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const onClick = () => setIsPlaying(!isPlaying);

  return (
    <div className={cn('showcase', { 'showcase--no-motion': !isPlaying })}>
      <div>
        <div className="showcase__content">
          <Button
            className="showcase__motion-toggle"
            iconOnly
            leadingIcon={isPlaying ? <SvgPause /> : <SvgPlay />}
            onClick={onClick}
            text={isPlaying ? 'play' : 'pause'}
            variant={Button.variants.secondaryWhite}
          />
          <div className="showcase__tagline">
            <Tagline {...tagline} onDark />
          </div>
          <div className="showcase__titles">
            <div className="showcase__blurb">
              <Text size={Text.sizes.large}>{secondaryTitle}</Text>
            </div>
            <div className="showcase__title">
              <Text size={Text.sizes.headline1} theme={Text.themes.emphasis}>
                {title}
              </Text>
            </div>
          </div>
          <div className="showcase__actions">
            {actions.map((entry, index) => (
              <div key={entry.href}>
                <LinkButton
                  {...entry}
                  size={LinkButton.sizes.large}
                  variant={
                    index
                      ? LinkButton.variants.ctaSecondaryWhite
                      : LinkButton.variants.cta
                  }
                />
              </div>
            ))}
          </div>
        </div>
        <div className="showcase__entries">
          {firstRowItems.map(entry => (
            <div
              className="showcase__entry showcase__entry--top"
              key={entry.key}
            >
              <BackgroundImage
                {...entry.image}
                defaultHeight={100}
                defaultWidth={100}
              />
              <div className="showcase__entry-text">
                <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
                  {entry.title}
                </Text>
              </div>
            </div>
          ))}
        </div>
        <div className="showcase__entries showcase__entries--bottom">
          {secondRowItems.map(entry => (
            <div
              className="showcase__entry showcase__entry--bottom"
              key={entry.key}
            >
              <BackgroundImage
                {...entry.image}
                defaultHeight={100}
                defaultWidth={100}
              />
              <div className="showcase__entry-text">
                <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
                  {entry.title}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Showcase;
